import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ConsumptionTrackingSidePanel } from "../../../common/components";
import { useApi } from "../../../common/hooks";
import { AiCompanyTokenQuotaService } from "../../../api";
import { isNonEmptyArray } from "../../../common/utils";
import { Flags, hasPermission, isFeatureEnabled, Permissions } from "../../../common/providers";

const allowedIntervals = ["DAILY", "WEEKLY"];
const CompanyTokenConsumption = ({ open, onClose }) => {
	const { call: getAllQuotasConsumptions } = useApi(AiCompanyTokenQuotaService.getAllQuotasConsumptions);
	const companyName = useSelector(({ context }) => context.company?.name);
	const [consumption, setConsumption] = useState(null);
	useEffect(() => {
		if (open && !hasPermission(Permissions.PLATFORM_ADMIN) && isFeatureEnabled(Flags.AI_QUOTA)) {
			getAllQuotasConsumptions()
				.then((data) => {
					setConsumption(data);
				})
				.catch(console.error);
		}
	}, [open, getAllQuotasConsumptions]);
	return (
		<>
			<ConsumptionTrackingSidePanel
				allowedIntervals={allowedIntervals}
				companyName={companyName}
				consumption={consumption}
				displayContactSupport={!isNonEmptyArray(consumption)}
				open={open}
				onClose={onClose}
			/>
		</>
	);
};

export default CompanyTokenConsumption;
